import {PageTitle} from '../../_metronic/layout/core'
import React, { useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import TabItem from '../../app/components/tabs/TabItem';
import OnboardingPage from "../../app/pages/onboarding/OnboardingPage";
import { reduxProps } from '../../constants';
import { actionGetStaffClassrooms } from '../../redux/education';
import { createStaffClassroom } from '../../services/education/staff.service';
import SchoolSettings from "../../components/Settings/school";
import UserSettings from "../../components/Settings/user";
import Step3, {RegistrationClassValues} from "../../components/Register/Step3";
import {registrationRequest} from '../../components/Register/registrationRequest';

export function Settings() {
  const location = useLocation();
  const dispatch = useDispatch();
  const isSettings = location.pathname === '/profile/settings';
  const [className, setClassName] = useState('');
  const { classroom, classrooms } = useSelector((state: reduxProps) => state.educationReducer);
  const {staffInfo} = useSelector((state:reduxProps)=>state.authReducer);
  const [classModalVisible, setClassModalVisible] = useState(false);
  const pendingClassroomId = useRef<number | null>(null);

  const educationUrl = "https://production.gokidly.com/education/api/v3";

  const handleAddClass = async (values: RegistrationClassValues, onCreated: (id: number) => void) => {
      const classroomPayload = {
        active: true,
        organizationId: 1,
        name: values.name,
        schoolId: classroom.schoolId,
        curriculumId: values.curriculumId,
        gradeLevelId: values.gradeLevelId,
        studentCount: values.studentCount,
      };
      if (!pendingClassroomId.current) {
        const newClassroom = await registrationRequest(`${educationUrl}/classroom`, classroomPayload, 'Sınıf oluşturulamadı.');
        pendingClassroomId.current = newClassroom.data.id;
      }
      onCreated(pendingClassroomId.current!);
      const relation = await createStaffClassroom({
          userId: staffInfo.id,
          classroomId: pendingClassroomId.current!
        });
      if (!relation.data?.id) throw new Error('Sınıf öğretmene bağlanamadı.');
      pendingClassroomId.current = null;
      setClassName('');
      dispatch(actionGetStaffClassrooms({userId: staffInfo.id}));
      setClassModalVisible(false);
  };

  const handleRemoveClass = async (classId: number) => {
    try {
      const response = await fetch(`${educationUrl}/classroom/${classId}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      });

      if (response.ok) {
        // Sınıf listesini yenile
        dispatch(actionGetStaffClassrooms({userId: staffInfo.id}));
      }
    } catch (error) {
      console.error("Hata oluştu:", error);
    }
  };

  return (
      <>
      <PageTitle description='Öğretmen, okul ve sınıf bilgilerinizi yönetin.'>Ayarlar</PageTitle>
        <div className="profile-tabs card">
          <div className="tab-list">
            <TabItem
                title="Profiliniz"
                isActive={!isSettings}
                icon={<i className="fa fa-user"></i>}
                to="/profile"
            />
            <TabItem
                title="Ayarlar"
                isActive={isSettings}
                icon={<i className="fa fa-cog"></i>}
                to="/profile/settings"
            />
          </div>
        </div>

        <div className="tab-content">
          {!isSettings ? (
              <OnboardingPage/>
          ) : (
              <div className="card">
                <div className="card-body py-3">
                  <div className="settings-container">
                    <p>Bu alandan <b>Sınıf, Okul ve Öğretmen</b> ayarlarını kontrol edebilirsiniz.</p>
                    <h2>Sınıf Ayarları</h2>

                    <div className="classroom-list">
                      <h3>Sınıflarım</h3>
                      <div className="classroom-items">
                        {classrooms.map((item, index) => (
                            <div key={index}
                                 className="classroom-item d-flex justify-content-between align-items-center">
                              <div className="d-flex align-items-center input-wrap gap-4">
                                <span className="item-number">{index + 1}-</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={item.name}
                                    readOnly
                                />
                              </div>
                              <button
                                  className="btn"
                                  onClick={() => handleRemoveClass(item.id as number)}
                              >
                                Bu sınıfı kaldır
                              </button>
                            </div>
                        ))}
                      </div>
                    </div>

                    <div className="add-classroom">
                      <button onClick={() => {pendingClassroomId.current = null; setClassModalVisible(true)}} type="submit" className="btn btn-primary">
                        Yeni Sınıf Ekle +
                      </button>
                      {/*<form onSubmit={handleAddClass} className="d-flex gap-4 align-items-center">*/}
                      {/*  <div className="form-group flex-grow-1">*/}
                      {/*    <input*/}
                      {/*        type="text"*/}
                      {/*        className="form-control"*/}
                      {/*        placeholder="Sınıf Adı"*/}
                      {/*        value={className}*/}
                      {/*        onChange={(e) => setClassName(e.target.value)}*/}
                      {/*    />*/}
                      {/*  </div>*/}
                      {/*  <button type="submit" className="btn btn-primary">*/}
                      {/*    Yeni Sınıf Ekle*/}
                      {/*  </button>*/}
                      {/*</form>*/}
                    </div>
                  </div>
                  <div className="settings-container">
                    <SchoolSettings/>
                  </div>
                  <div className="settings-container">
                    <UserSettings/>
                  </div>
                </div>
              </div>
          )}
        </div>
        {
            classModalVisible && <div id="addStudentModal" className="modal-overlay">
              <div className="modal-content">
                <button onClick={() => setClassModalVisible(false)} className="modal-close">
                  x
                </button>
                <Step3 fromSettings={true} handleAddClass={handleAddClass} />
              </div>
            </div>
        }
      </>
  );
}
